<template>
    <div v-bind="getRootProps()">
        <input v-bind="getInputProps()" />
        <div id="" class="dropZoneOut">
            <img v-if="state.src" id="imgUpload1" :src="state.src" alt="" class="" style="max-height:100px; max-width:300px;">
            <div v-else id="dropZone1">
                <span class="dropZoneText">Drop file here</span>
            </div>
        </div>
        <table class="dxuc-root dxucControl_Material uploadControl" id="masterBody_upload1" style="width:100%;">
        <tbody><tr>
            <td style="width:100%;vertical-align:top;"><table id="masterBody_upload1_UploadInputs" class="dxucInputs_Material" style="width:100%;border-collapse:separate;">
                <tbody><tr id="masterBody_upload1_FIT" style="display:none;">
                    <td id="masterBody_upload1_TextBoxT" class="dxTB dxucTextBox_Material dx-al" style="width:100%;border-right-style:Solid;border-right-width:0px;"><input id="masterBody_upload1_TextBoxT_Input" class="dxTI" type="file" accept=".jpg,.png,.jpeg,.gif,.docx,.pdf,.doc" style="position:absolute;filter:alpha(opacity=0);opacity:0;top:-5000px;z-index:29999;"><input id="masterBody_upload1_TextBoxT_FakeInput" class="dxTF dxucEditArea_Material" type="text" readonly="readonly" tabindex="-1" style="background-color:Transparent;border-width:0px;width:100%;"></td><td id="masterBody_upload1_ClearBoxT" class="dxCB dxucTextBox_Material" style="border-left-style:Solid;border-left-width:0px;border-right-style:Solid;border-right-width:0px;"><a href="javascript:;" style="visibility:hidden;"><img id="masterBody_upload1_ClearBoxTImg" title="Clear selection" class="dxWeb_ucClearButton_Material" src="" alt="Clear selection" style="display:inline;"></a></td><td id="masterBody_upload1_BrowseT" class="dxBB dxucBrowseButton_Material"><a tabindex="-1" href="javascript:;">Upload file</a></td>
                </tr><tr id="masterBody_upload1_ErrRRT" style="display:none;">
                    <td class="dxucErrorCell_Material validationMessage" colspan="3"></td>
                </tr><tr class="dxucSR" style="display:none;">
                    <td colspan="3" style="font:0;height:2px;"></td>
                </tr><tr id="masterBody_upload1_FI0">
                    <td id="masterBody_upload1_TextBox0" savedclass="dxTB dxucTextBox_Material dx-al"
                        savedstyle="width:100%;border-right-style:Solid;border-right-width:0px;"
                        class="dxucTextBox_Material dxucNullText_Material"
                        style="border-right-width: 0px; width: 100%;"><input id="masterBody_upload1_TextBox0_Input"
                                                                             class="dxTI dxucgen-1_dxFITextBoxHover"
                                                                             type="file"
                                                                             accept=".jpg,.png,.jpeg,.gif,.docx,.pdf,.doc"
                                                                             style="position: absolute; opacity: 0; top: -42.1875px; z-index: 29999; left: -673.5px;"><input
                        id="masterBody_upload1_TextBox0_FakeInput" class="dxTF dxucEditArea_Material" type="text"
                        readonly="readonly" tabindex="-1"
                        savedstyle="background-color:Transparent;border-width:0px;width:100%;"
                        style="background-color: transparent; border-width: 0px; width: 100%;"></td>
                    <td id="masterBody_upload1_ClearBox0"
                        savedstyle="border-left-style:Solid;border-left-width:0px;border-right-style:Solid;border-right-width:0px;"
                        savedclass="dxCB dxucTextBox_Material" class="dxucTextBox_Material dxucNullText_Material dxCB"
                        style="border-left-width: 0px; border-right-width: 0px;"><a href="javascript:;"
                                                                                    style="visibility:hidden;"><img
                        id="masterBody_upload1_ClearBox0Img" title="Clear selection"
                        class="dxWeb_ucClearButton_Material" src="" alt="Clear selection" style="display:inline;"></a>
                    </td>
                    <td id="masterBody_upload1_Browse0" class="dxBB dxucBrowseButton_Material">
                        <a tabindex="-1" href="javascript:;">
                            {{ (state.src && state.src.length) || state.file ? 'Upload another image' : 'Upload file' }}
                        </a>
                    </td>
                </tr><tr id="masterBody_upload1_ErrR0" style="display:none;">
                    <td class="dxucErrorCell_Material validationMessage" colspan="3"></td>
                </tr>
                </tbody></table><table id="masterBody_upload1_ProgressPanel" style="width:100%;display:none;">
                <tbody><tr>
                    <td style="vertical-align:middle;"><table style="width:100%;">
                        <tbody><tr>
                            <td><table class="dxucProgressBar_Material uploadControlProgressBar" id="masterBody_upload1_UCProgress" style="width:100%;border-collapse:separate;">
                                <tbody><tr>
                                    <td class="dxPBMainCell"><div id="masterBody_upload1_UCProgress_DI" class="dxucProgressBarIndicator_Material" style="width:0%;">

                                    </div><table style="width:100%;margin-top:0px;">
                                        <tbody><tr>
                                            <td id="masterBody_upload1_UCProgress_VIC" class="dx" style="text-align:Center;vertical-align:Middle;"><div class="dxpbVC">
                                                0%
                                            </div></td>
                                        </tr>
                                        </tbody></table></td>
                                </tr>
                                </tbody></table></td>
                        </tr><tr>
                            <td style="font:0;height:13px;"></td>
                        </tr><tr>
                            <td class="dx-ac"><table>
                                <tbody><tr>
                                    <td id="masterBody_upload1_Cancel" class="dxucButton_Material dxucDisabled_Material dxucButtonDisabled_Material"><a href="javascript:;" tabindex="-1" unselectable="on">Cancel</a></td>
                                </tr>
                                </tbody></table></td>
                        </tr>
                        </tbody></table></td>
                </tr>
                </tbody></table><div id="masterBody_upload1_CErr" class="dxucErrorCell_Material validationMessage" style="padding-top:13px;display:none;">
                Common error text is displayed here
            </div><table id="masterBody_upload1_PlatformErrorPanel" class="dxucSilverlightPluginLinkPanel_Material" style="display:none;">
                <tbody><tr>
                    <td>Please use a browser with HTML5 support; or install <a href="http://go.microsoft.com/fwlink/?LinkID=149156">Microsoft Silverlight v3 or later</a> to view this content and have an ability to upload files.</td>
                </tr>
                </tbody></table></td>
        </tr>
        </tbody></table>
    </div>
</template>

<script setup>

import { reactive, watch, defineEmits } from "vue";
import { useDropzone } from 'vue3-dropzone';
const emit = defineEmits(['changeFile']);

const props = defineProps({
    src: {
        type: String,
    }
})

const state = reactive({
    file: null,
    src: props.src ? props.src : null,
});

const { getRootProps, getInputProps, ...rest } = useDropzone({
    onDrop,
});

watch(state, () => {
    emit('changeFile', state)
});
watch(props.src, () => {
    state.src = props.src
});

function onDrop(acceptFiles, rejectReasons) {
    state.file = acceptFiles[0];
    state.src = URL.createObjectURL(acceptFiles[0])
}
</script>
<style scoped>
.dropZoneText {
    background-color: white!important;
    color: #808080!important;
}
.dropZoneOut {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
}
.dropZoneOut {
    width: 100%;
    text-align: center;
    height: 120px;
    position: relative;
    border: 2px dashed #ccc!important;
    cursor: pointer;
}
.border-top_none .dropZoneOut {
    border-top: none!important;
}
.dragZoneText {
    color: #808080;
}
.dropZoneText, .dragZoneText {
    display: inline-block;
    text-align: center;
    line-height: 100px;
    cursor: pointer;
}
.uploadControl {
    width: 100%;
    cursor: pointer;
}
.dxucControl_Material .dxucInputs_Material {
    border-collapse: separate;
    border-width: 0;
}
.dxuc-root table {
    font-size: inherit;
}
.dxucTextBox_Material {
    background-color: white;
    border: 1px solid #DFDFDF;
    padding: 1px 8px;
}
.dxucEditArea_Material, input[type="text"].dxucEditArea_Material {
    padding: 1px;
}
.dxucTextBox_Material {
    background-color: white;
    border: 1px solid #DFDFDF;
    padding: 1px 8px;

}
.dxucBrowseButton_Material {
    border: 1px solid #DFDFDF;
    padding: 6px 18px 8px;
    background-color: #EEEEEE;
    border-radius: 0 2px 2px 0;
    -webkit-border-radius: 0 2px 2px 0;
}
.dxucBrowseButton_Material, .dxucBrowseButton_Material a {
    cursor: pointer;
    white-space: nowrap;
    text-decoration: none;
}
.dxucBrowseButton_Material, .dxucBrowseButton_Material a {
    cursor: pointer;
    white-space: nowrap;
    text-decoration: none;
}
</style>
